import fetch from '@/plugin/axios'

// 新增抽奖
export function getLuckDraw (query) {
  return fetch({
    url: '/api/order/lucky-draw/add',
    method: 'Post',
    data: query
  })
}

// 抽奖活动列表
export function getLuckList (query) {
  return fetch({
    url: '/api/order/lucky-draw/list',
    method: 'Post',
    data: query
  })
}

// 修改活动列表
export function getLuckUpdate (query, id) {
  return fetch({
    url: `/api/order/lucky-draw/update/${id}`,
    method: 'Post',
    data: query
  })
}

// 详情
export function getLuckInfo (id) {
  return fetch({
    url: `/api/order/lucky-draw/info/${id}`,
    method: 'Get'
  })
}
// 关闭
export function getLuckClose (id) {
  return fetch({
    url: `/api/order/lucky-draw/close/${id}`,
    method: 'Get'
  })
}
// 开启
export function getLuckOpen (id) {
  return fetch({
    url: `/api/order/lucky-draw/open/${id}`,
    method: 'Get'
  })
}

// 抽奖记录
export function getLog (query) {
  return fetch({
    url: '/api/order/lucky-draw/log',
    method: 'Post',
    data: query
  })
}
